import { render, staticRenderFns } from "./PriceListChangeActivationType.vue?vue&type=template&id=3f71d7e6&"
import script from "./PriceListChangeActivationType.vue?vue&type=script&lang=js&"
export * from "./PriceListChangeActivationType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports